export default __webpack_public_path__ + "static/media/20.c80791e0.jpg";